import type { BeneficialOwnerData, BeneficialOwnerResponse } from '@gcv/shared';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { BeneficialOwnerApi } from 'api';
import { DISPENSARY_BENEFICIAL_OWNERS_KEY } from 'tanstack-hooks/keys';

export function useCrbCreateBeneficialOwner(dispensaryId: string) {
  const beneficialOwnerApi = new BeneficialOwnerApi();
  const queryClient = useQueryClient();

  const { mutate: createBeneficialOwner, isPending: isCreatingBeneficialOwner } = useMutation({
    mutationKey: [DISPENSARY_BENEFICIAL_OWNERS_KEY, dispensaryId],
    mutationFn: ({
      beneficialOwner,
      questionnaireBankId
    }: {
      beneficialOwner: BeneficialOwnerData;
      questionnaireBankId?: string;
    }) => beneficialOwnerApi.crbCreateBeneficialOwner(dispensaryId, beneficialOwner, questionnaireBankId),
    onSuccess: (createdOwner) => {
      return queryClient.setQueryData(
        [DISPENSARY_BENEFICIAL_OWNERS_KEY, dispensaryId],
        (old: BeneficialOwnerResponse[] | undefined) => (old ?? []).concat(createdOwner)
      );
    },
    meta: {
      snackbarSuccessMessage: 'Beneficial owner added successfully.',
      snackbarErrorMessage: 'There was an issue adding beneficial owner.'
    }
  });

  return { createBeneficialOwner, isCreatingBeneficialOwner };
}
